export type MpLegalDocs = {
  version: string;
  user_agreement: string;
  privacy_policy: string;
  publish_rules: string;
};

export type MiniproPublishMode = 'legacy' | 'user_self';

export const PUBLISH_MODE_LABELS: Record<MiniproPublishMode, string> = {
  legacy: '传统运营（站长/表单/客服导流）',
  user_self: '用户自助发布（二手闲置 · 微信登录）',
};

export function defaultMpLegalDocs(platformName?: string): MpLegalDocs {
  const name = (platformName || '').trim() || '本平台';
  const version = '2026-06-11';
  return {
    version,
    user_agreement: `# ${name}用户服务协议\n\n更新日期：2026年6月11日\n\n（可在管理端编辑完整正文；保存后小程序端同步生效。）`,
    privacy_policy: `# ${name}隐私政策\n\n更新日期：2026年6月11日\n\n（可在管理端编辑完整正文；保存后小程序端同步生效。）`,
    publish_rules: `# ${name}二手闲置发布规范\n\n更新日期：2026年6月11日\n\n（可在管理端编辑完整正文；保存后小程序端同步生效。）`,
  };
}

export function normalizeMpLegalDocs(raw: unknown, platformName?: string): MpLegalDocs {
  const d = defaultMpLegalDocs(platformName);
  if (!raw || typeof raw !== 'object') return d;
  const o = raw as Record<string, unknown>;
  return {
    version: String(o.version || d.version).trim() || d.version,
    user_agreement: String(o.user_agreement || d.user_agreement).trim() || d.user_agreement,
    privacy_policy: String(o.privacy_policy || d.privacy_policy).trim() || d.privacy_policy,
    publish_rules: String(o.publish_rules || d.publish_rules).trim() || d.publish_rules,
  };
}

export function normalizePublishMode(raw: unknown): MiniproPublishMode {
  return raw === 'user_self' ? 'user_self' : 'legacy';
}
